export default "__VITE_ASSET__58580401__"